import DevicePermissionStatus from "@mapmycustomers/shared/types/DevicePermissionStatus";
import User from "@mapmycustomers/shared/types/User";

import PermissionsReportRow from "../types/PermissionsReportRow";

import { NEVER_REPORTED_SIGNALS } from "./consts";
import getDeviceStatuses from "./getDeviceStatuses";
import rollupStatuses from "./rollupStatuses";

const buildDeviceRow = (
  user: User,
  device: DevicePermissionStatus,
  hasMileageTracking: boolean
): PermissionsReportRow => ({
  ...getDeviceStatuses(device, hasMileageTracking),
  appVersion: device.appVersion,
  deviceCount: 1,
  deviceModel: device.deviceModel,
  isDeviceRow: true,
  key: `${user.id}-${device.deviceId}`,
  platform: device.platform,
  user,
});

const buildRepRow = (user: User, orgSupportsMileageTracking: boolean): PermissionsReportRow => {
  // A seat flag left on after the org drops the add-on must not un-gate the columns.
  const hasMileageTracking = orgSupportsMileageTracking && !!user.addOns?.mileageTracking;
  // An absent key means the viewer is not entitled; the gated route makes that unreachable.
  const devices = user.devicePermissions ?? [];

  if (!devices.length) {
    return {
      ...getDeviceStatuses(NEVER_REPORTED_SIGNALS, hasMileageTracking),
      appVersion: null,
      deviceCount: 0,
      deviceModel: null,
      isDeviceRow: false,
      key: String(user.id),
      platform: null,
      user,
    };
  }

  if (devices.length === 1) {
    return {
      ...buildDeviceRow(user, devices[0], hasMileageTracking),
      isDeviceRow: false,
      key: String(user.id),
    };
  }

  return {
    ...rollupStatuses(devices.map((device) => getDeviceStatuses(device, hasMileageTracking))),
    appVersion: null,
    children: devices.map((device) => buildDeviceRow(user, device, hasMileageTracking)),
    deviceCount: devices.length,
    deviceModel: null,
    isDeviceRow: false,
    key: String(user.id),
    platform: null,
    user,
  };
};

const buildPermissionsReportRows = (
  users: User[],
  orgSupportsMileageTracking: boolean
): PermissionsReportRow[] => users.map((user) => buildRepRow(user, orgSupportsMileageTracking));

export default buildPermissionsReportRows;
